export const OperatorConnectURLProps={
    index:"/",
    pageNotFound: "/page-not-found",
    page404: "/404",
    error:"/error",
      productManagement:{
        productView:"/products/:pid/view"
    },
    orderManagement:{
        quoteAdd:"/quotes/add",
        quoteUpdate:"/quotes/update",
        quoteOrders: "/quotes",

    }
}